export default "__VITE_ASSET__DqfD7HWq__"